import {BehaviorSubject, Subject, combineLatest, switchMap} from 'rxjs';
import {debounceTime, filter} from 'rxjs/operators';
import {PriceType} from '@px/enum/perpetual';
import {STORAGE_KEY_CONTRACT, tradingViewStorage} from '@px/storage/trading-view';
import {contractBiz$, updateCustomize} from '@px/streams-contract/contract-biz';
import {isLogin$} from './auth';

const BIZ_KEY = 'tvSetting';

export const tvIsFullScreen$ = new BehaviorSubject(false);
export const isDrag$ = new BehaviorSubject(false);
export const tvSetting$ = new BehaviorSubject(initTvSetting());
export const customizeUpdate$ = new Subject<void>();
export const priceType$ = new BehaviorSubject(tradingViewStorage.readPriceType(STORAGE_KEY_CONTRACT) || PriceType.Last);

// contract customize version
const version$ = new BehaviorSubject(1);

function initTvSetting() {
  return {
    favoriteIntervals: ['1', '5', '15', '30', '60', '180', '240', '360', '720', '1D', '1W'],
    quickPlaceMarketOrder: true,
    quickPlaceLimitOrder: true,
    activeOrderLine: true,
    conditionalOrderLine: true,
    takeProfitStopLossLine: true,
    liquidationLine: false,
    positionLine: true,
    closePositionConfirm: true,
    reversePositionConfirm: true,
    labelPosition: 'Right',
    orderHistory: true,
    estPnl: true,
  };
}

contractBiz$.subscribe((items) => {
  const item = items.find((item) => item.bizKey === BIZ_KEY);
  if (item) {
    tvSetting$.next({...initTvSetting(), ...JSON.parse(item.bizVal)});
    version$.next(item.version);
  }
});

combineLatest([isLogin$, tvSetting$, customizeUpdate$])
  .pipe(
    debounceTime(1000),
    filter(([isLogin]) => isLogin),
    switchMap(([_, settings]) => {
      const curVersion = version$.getValue();
      return updateCustomize({bizKey: BIZ_KEY, curVersion, settings});
    })
  )
  .subscribe((version: number) => version$.next(version));
